import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class CohortResult extends Model<Schemas['cohortResults'], Models> {}
